import React, { useContext, useState } from "react";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import "./style.scss";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { NavLink } from "react-router-dom";
import { QuestionsContextMemorySpace } from "../../../contexts/questions/questionsContext";
import ingresarIcono from "../../../assets/img/person.svg";

const DrawerMicrositio = () => {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const { question } = useContext(QuestionsContextMemorySpace);

  const toggleDrawer = (anchor) => {
    setState((prevState) => ({ ...prevState, [anchor]: !prevState[anchor] }));
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : "63vw" }}
      role="presentation"
      onClick={() => toggleDrawer(anchor)}
      onKeyDown={() => toggleDrawer(anchor)}
      className="drawer"
    >
      <div style={{ minHeight: "100vh", backgroundColor: "#efefef" }}>
        <aside className="asideWebHBMobileMicro d-flex flex-column justify-content-between" style={{height:"calc(100vh - 80px)"}}>
          <div className="d-flex flex-column" style={{ width: "100%" }}>
            <div
              className="d-flex flex-column justify-content-center"
              style={{ width: "100%", backgroundColor: "#efefef" }}
            >
              <span style={{marginLeft:"15px",marginBottom:"15px",color:"#05294f",fontWeight:"bold"}}>Categorías de búsqueda</span>
              {question.map((item) => (
                <NavLink
                  key={item.id}
                  className="navigate-button"
                  to={`/micrositio/${item.slug}`}
                  activeclassname="active"
                >
                  <div className="d-flex textoMenuLateral">
                    <img
                      src={item?.icono?.url}
                      className="iconosAtencion"
                      alt={item.titulo}
                    />{" "}
                    <span>{item.titulo}</span>
                  </div>
                </NavLink>
              ))}
            </div>
          </div>

          <NavLink
                  key={"iniciarSesion"}
                  className="navigate-button"
                  to={`/`}
                  activeclassname="active"
                >
                  <div className="d-flex textoMenuLateral justify-content-center">
                    <img
                      src={ingresarIcono}
                      className="iconosAtencion"                      
                      style={{marginLeft:"0px"}}
                    />{" "}
                    <span>Ingresar</span>
                  </div>
                </NavLink>
        </aside>
      </div>
    </Box>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <i
            className="bi bi-list"
            onClick={() => toggleDrawer(anchor)}
            style={{ fontSize: "30px", color: "#0062C1" }}
          ></i>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            // sx={{
            //   width: 240, // Ancho fijo en píxeles
            //   flexShrink: 0,
            //   [`& .MuiDrawer-paper`]: { width: 240, boxSizing: 'border-box' },
            // }}
            sx={{
              zIndex:1,
              "& .MuiDrawer-paper": {
                top: 80, // Posiciona el Drawer debajo del Navbar                
              },
              "& .MuiBackdrop-root": {
                top: 80, // Posiciona el Backdrop debajo del Navbar
                height: `calc(100% - ${80}px)`, // Ajusta el tamaño del Backdrop
              },
            }}
            onClose={() => toggleDrawer(anchor)}
          >            
            {list(anchor)}           
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
};

export default DrawerMicrositio;
